const reputationCoreNewPermissions = (
  action,
  permissions,
  institutionId,
) => {
  if (action === 'reputation_core_new:view_tableau_dashboard' &&
    institutionId in permissions &&
    permissions[institutionId].some(item => item.match(/^REPUTATION_CORE_NEW_[0-9]{4}$/))
  ) {
    return true;
  }

  return false;
};

module.exports = {
  reputationCoreNewPermissions,
};
